module.exports = __webpack_public_path__ + "static/ABA_2021-Finalist__OFFICE OF THE YEAR – NON-FRANCHISE-6491164ca9b10c8ea6a2b4f422963cc9.png";